/**
 * Robust copy-to-clipboard with fallback for browsers that block
 * navigator.clipboard.writeText (Safari without HTTPS, lost focus, etc.)
 *
 * Returns true on success, false on failure.
 */
export async function copyToClipboard(text) {
  // Primary path — modern Clipboard API (HTTPS or localhost only)
  if (typeof navigator !== 'undefined' && navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (_e) {
      // fall through to the legacy path
    }
  }

  // Fallback — hidden textarea + document.execCommand('copy')
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    // Avoid scrolling to bottom
    ta.style.position = 'fixed';
    ta.style.top = '0';
    ta.style.left = '0';
    ta.style.width = '2em';
    ta.style.height = '2em';
    ta.style.padding = '0';
    ta.style.border = 'none';
    ta.style.outline = 'none';
    ta.style.boxShadow = 'none';
    ta.style.background = 'transparent';
    ta.setAttribute('readonly', '');
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    ta.setSelectionRange(0, text.length);
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return !!ok;
  } catch (_e) {
    return false;
  }
}
